export class OpenAttachmentsPopupItem {
    public fileTitle: string;
    public openFileCallback: () => void;

    constructor(init?: Partial<OpenAttachmentsPopupItem>) {
        Object.assign(this, init);
    }
}
